import DurationPopover from '@koob/experiences/src/components/DurationPopover';
import PriceRangePopover from '@koob/experiences/src/components/PriceRangePopover';
import KoobButton from '@koob/ui/src/components/KoobButton';
import KoobInputSegmented from '@koob/ui/src/components/KoobInputSegmented';
import { useTripFilters } from '../../hooks/useTripStoreSelectors';
import { useUpdateTripFilter } from '../../hooks/useUpdateTripFilter';

interface Props {
  t: (key: string) => string;
  currency?: string;
  // Shows the "Transition Programs" toggle.
  transitionPrograms?: boolean;
}

// The experience filters behind "More filters".
export default function TripFilterMore({
  t,
  currency,
  transitionPrograms,
}: Props) {
  const tripFilters = useTripFilters();
  const updateFilter = useUpdateTripFilter();

  return (
    <div className="flex flex-wrap items-center gap-2">
      <DurationPopover
        translation={t}
        value={tripFilters?.expDuration}
        onChange={(value: unknown) => updateFilter('expDuration', value)}
      />

      <PriceRangePopover
        translation={t}
        value={tripFilters?.priceRange ?? [0, null]}
        onChange={(value: unknown) => updateFilter('priceRange', value)}
        currency={currency}
      />

      {/* KD-3850: guided, not guided, or both. */}
      <KoobInputSegmented
        value={tripFilters?.guided}
        onChange={(value: unknown) => updateFilter('guided', value)}
        options={[
          { value: undefined, label: t('search.all') },
          { value: true, label: t('search.guided') },
          { value: false, label: t('search.notGuided') },
        ]}
      />

      {transitionPrograms && (
        <KoobButton
          rounded="full"
          variant={
            tripFilters?.transitionProgramsOnly ? 'primary' : 'secondary'
          }
          onClick={() =>
            updateFilter(
              'transitionProgramsOnly',
              !tripFilters?.transitionProgramsOnly,
            )
          }
        >
          <i className="far fa-exchange-alt" />
          <span>{t('search.transitionProgramsOnly')}</span>
        </KoobButton>
      )}
    </div>
  );
}
